module.exports = __webpack_public_path__ + "static/img/icon-vip-y.4f39a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/icon-vip-y.png
// module id = UOS/
// module chunks = 21